import { I18n } from '@/i18n/I18n';


export function BasicButton(props: { onClick: Function, label: string, className?: string, disabled?: boolean, processing?: boolean, style?: React.CSSProperties, title?: string, processingLabel?: string }) {
  const { onClick, label, className, disabled, processing, style, title, processingLabel } = props;

  const buttonDisabled = disabled || processing;

  return (
    <button
      className={ className || 'btn btn-sm btn-secondary'}
      style={{ ...style, maxWidth: 'fit-content' }}
      type="button"
      onClick={(e) => onClick(e)}
      aria-label={label}
      title={title || label}
      disabled={buttonDisabled}
    >
      { processing && <div className='d-flex gap-2 align-items-center'>
        { processingLabel && <p className="my-auto text-nowrap">{processingLabel}</p> }
        <span className='spinner-border spinner-border-sm my-auto' role='status' aria-hidden='true' aria-label={I18n.get('loading')} />
      </div>}
      { !processing && <p className="my-auto text-nowrap">{label}</p> }
    </button>
  );
}
